module.exports = __webpack_public_path__ + "static/media/pancakeswap-bot.8f561d91.md";